import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { FilterProvider } from './context/FilterContext';
import { ThemeProvider } from './context/ThemeContext';
import AppErrorBoundary from './components/AppErrorBoundary';
import AppFeedbackCenter from './components/AppFeedbackCenter';
import ConnectivityBanner from './components/ConnectivityBanner';
import RouteExperience from './components/RouteExperience';
import { installClientErrorReporting } from './services/clientErrorService';

installClientErrorReporting();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        <ThemeProvider>
          <FilterProvider>
            <RouteExperience />
            <ConnectivityBanner />
            <AppFeedbackCenter />
            <AppErrorBoundary>
              <App />
            </AppErrorBoundary>
          </FilterProvider>
        </ThemeProvider>
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>
);
